import React from 'react';
import PropTypes from 'prop-types';

const ComboboxFooter = ({ children }) => (
  <li className="combobox__footer" role="presentation">
    {children}
  </li>
);

ComboboxFooter.propTypes = {
  children: PropTypes.node,
};

export default ComboboxFooter;
